import React, { Component } from 'react';
import { app, dialog, authentication } from "@microsoft/teams-js";
import { initializeIcons } from "@fluentui/react";
import * as AdaptiveCards from "adaptivecards";

import httpHelpers from './httpHelpers.js';
import "./AdaptiveCardProxy.css"
import { lightHostConfig } from "./AdaptiveCards/lightThemeHostConfig.js";
import { darkHostConfig } from "./AdaptiveCards/darkThemeHostConfig.js";
import { InputChoiceSetFluentUI } from "./AdaptiveCards/InputChoiceSetFluentUI.js";
import { registerAdaptiveCardCharts, enableAdaptiveCardChartHostCapabilities } from "./AdaptiveCards/ChartElements.js";
import { registerActionPopover, wireCopyPopoverActions } from "./AdaptiveCards/ActionPopover.js";
import { setAdaptiveCardSearch, clearAdaptiveCardSearch } from "./adaptiveCardSearchBridge.js";

registerAdaptiveCardCharts();
registerActionPopover();

let iconsInitialized = false;


const BOT_ACTION_NAME = {
    TASK_FETCH: "task/fetch",
    TAB_FETCH: "tab/fetch",
    TASK_SUBMIT: "task/submit"
};

const loadingCard = {
    "type": "AdaptiveCard",
    "$schema": "https://AdaptiveCards.io/schemas/adaptive-card.json",
    "version": "1.5",
    "body": [
        {
            "type": "Image",
            "url": "https://app.centro.rocks/loading.gif"
        }
    ]
};
const errorCard = {
    "type": "AdaptiveCard",
    "version": "1.5",
    "body": [
        {
            "type": "TextBlock",
            "text": "App Offline",
            "wrap": true,
            "style": "heading"
        },
        {
            "type": "TextBlock",
            "text": "Check your network connection and try again.",
            "wrap": true
        }
    ],
    "$schema": "https://adaptivecards.io/schemas/adaptive-card.json"
};

const unsupportedPlatformCard = {
    "type": "AdaptiveCard",
    "version": "1.5",
    "body": [
        {
            "type": "TextBlock",
            "text": "Unsupported Platform",
            "wrap": true,
            "style": "heading"
        },
        {
            "type": "TextBlock",
            "text": "This feature is only available in Microsoft Teams App Home Tab.",
            "wrap": true
        }
    ],
    "$schema": "https://adaptivecards.io/schemas/adaptive-card.json"
};

const endpointMap = {
    // Dev
    "e3a7ca1c-da24-41d4-8cf5-237de1d10562": "https://centro-api.baileycarlson.net/v1",
    // Production
    "0761e52a-4037-4dee-a41e-2cea8d27eb3e": "https://api.centro.rocks/v1",
    // Staging
    "3c837692-f74b-4717-b980-04ae3621ab9b": "https://staging.centro.rocks/v1",
    "a6943022-dd5b-4c5f-8cf7-cc6e854b99c3": "https://staging.centro.rocks/v1"
};

const botIdMap = {
    // Dev
    "e3a7ca1c-da24-41d4-8cf5-237de1d10562": "269d23bc-b85b-4f21-b095-514273672622",
    // Production
    "0761e52a-4037-4dee-a41e-2cea8d27eb3e": "83ae83ff-2c6a-4daf-9e1f-759f4754e3c3",
    // Staging
    "3c837692-f74b-4717-b980-04ae3621ab9b": "6e811cf1-8b55-4735-b51c-a5cbc35e21d6",
    "a6943022-dd5b-4c5f-8cf7-cc6e854b99c3": "6e811cf1-8b55-4735-b51c-a5cbc35e21d6"

};

const appIdMap = {
    // Prod
    "0761e52a-4037-4dee-a41e-2cea8d27eb3e": "c0a884f8-cfae-4657-bc90-db3ed5d373a2",
    // Staging
    "3c837692-f74b-4717-b980-04ae3621ab9b": "1751295a-ade2-4208-a41d-739f62ff942c",
    "a6943022-dd5b-4c5f-8cf7-cc6e854b99c3": "1751295a-ade2-4208-a41d-739f62ff942c",
    // Dev
    "e3a7ca1c-da24-41d4-8cf5-237de1d10562": "4ce552ac-ecad-4bfb-a80a-cc9424b11a6e"
}

class AdaptiveCardProxy extends Component {

    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.renderCard = this.renderCard.bind(this);
        this.submitAction = this.submitAction.bind(this);
        this.fetchAdaptiveCardSearch = this.fetchAdaptiveCardSearch.bind(this);
        this.getCardInputData = this.getCardInputData.bind(this);
    }

    fetchAdaptiveCard(type, entityId = this.state.tabId) {
        // Make a fake request like botbuilder does for legacy tab invoke events
        const endpoint = endpointMap[this.state.appId];
        const requestPayload = {
            "name": type,
            "type": "invoke",
            "from": {
                "name": this.state.userDisplayName,
                "aadObjectId": this.state.userId
            },
            "channelData": {
                "tenant": {
                    "id": this.state.tenantId
                },
                "team": {
                    "id": this.state?.teamId
                }
            },
            "conversation": {
                "id": this.state.conversationId
            },
            "value": {
                "tabContext": {
                    "tabEntityId": this.state.tabId
                },
                "data": entityId
            }
        };
        return httpHelpers.request(endpoint + "/teams", "POST", JSON.stringify(requestPayload)).catch(e => {
            console.log("failed to retrieve adaptive card view from backend");
            console.log(e);
        });
    }

    fetchAdaptiveCardSearch(searchText, dataSet) {
        const endpoint = endpointMap[this.state?.appId];
        const requestPayload = {
            "name": "application/search",
            "type": "invoke",
            // "timestamp": "2026-04-06T21:31:16.327Z",
            // "localTimestamp": "2026-04-06T14:31:16.327-07:00",
            // "id": "f:7fb4aac7-9fdd-deb9-568c-0b3bf61b3f77",
            // "channelId": "msteams",
            // "serviceUrl": "https://smba.trafficmanager.net/amer/8ec1762a-a6a9-4862-b76a-4a61b19a4086/",
            "from": {
                "name": this.state?.userDisplayName,
                "aadObjectId": this.state?.userId
            },
            "conversation": {
                "id": this.state?.conversationId,
            },
            "channelData": {
                "tenant": {
                    "id": this.state?.tenantId
                },
                "team": {
                    "id": this.state?.teamId
                }
            },
            "value": {
                "queryText": searchText,
                "queryOptions": {
                    "skip": 0,
                    "top": 15
                },
                "dataset": dataSet,
                "data": this.getCardInputData()
            },
            // "locale": "en-US",
            // "localTimezone": "America/Denver"
        };
        return httpHelpers.request(endpoint + "/teams", "POST", JSON.stringify(requestPayload), this.state.authToken).catch(e => {
            console.log("failed to retrieve adaptive card view from backend");
            console.log(e);
        });
    }

    async submitAction(action) {
        if (action instanceof AdaptiveCards.SubmitAction || action instanceof AdaptiveCards.ExecuteAction) {
            // Fetch card from lambdas before display dialog
            const isTaskDialog = this.state.frameContext === "task";
            if (action.data?.actionid === "CANCEL") return dialog.url.submit();
            let response;
            try {
                let restoreClass;
                if (action?.renderedElement) {
                    // Disable button while fetching card
                    action.renderedElement.disabled = true;
                    restoreClass = action.renderedElement.className;
                    action.renderedElement.className = "ac-pushButton-disabled";
                }
                response = await this.fetchAdaptiveCard(isTaskDialog ? BOT_ACTION_NAME.TASK_SUBMIT : BOT_ACTION_NAME.TASK_FETCH, action.data);
                if (action?.renderedElement) {
                    // Renable button
                    action.renderedElement.disabled = false;
                    action.renderedElement.className = restoreClass;
                }
            }
            catch (e) {
                console.log("Failed to fetch card");
                console.log(e);
            }
            if (response && action.data?.msteams?.type === "task/fetch" && !response?.taskWeb) {
                // Open card dialogue if action has task/fetch msteams metadata in it
                let card = response.task?.value?.card?.content;
                const botId = botIdMap[this.state.appId] || "83ae83ff-2c6a-4daf-9e1f-759f4754e3c3";
                if (!card) card = errorCard;
                let taskInfo = {
                    title: action.title,
                    size: {
                        width: response.task?.value?.width || 520,
                        height: response.task?.value?.height,
                    },
                    card: JSON.stringify(card),
                    completionBotId: botId,
                };
                const isSupported = dialog.adaptiveCard.bot.isSupported();
                if (isSupported) {
                    if (isTaskDialog) {
                        // Update existing dialog in place
                        this.renderCard(card);
                        dialog.update.resize({ width: taskInfo.size.width, height: taskInfo.size.height });
                    }
                    else {
                        dialog.adaptiveCard.bot.open(taskInfo, (err, result) => {
                            if (action.data?.msteams?.refreshOnSubmit !== undefined) {
                                // Reload the tab if submitting dialog requires a refresh
                                window.location.reload();
                            }
                            if (err) console.log(err);
                            if (result) console.log(result);
                        });
                    }
                }
                else {
                    // Show unsupported platform modal with button to Teams app home
                    const appid = appIdMap[this.state.appId] || "c0a884f8-cfae-4657-bc90-db3ed5d373a2";
                    unsupportedPlatformCard.actions = [{
                        type: "Action.OpenUrl",
                        style: "positive",
                        title: "Take me there",
                        url: `https://teams.microsoft.com/l/entity/${encodeURIComponent(appid)}/homeTab`
                    }];
                    this.renderCard(unsupportedPlatformCard);
                }

            }
            else if (response?.taskWeb) {
                const viewId = Math.random().toString(16).replace("0.", "");
                const card = response.taskWeb?.value?.card?.content;
                const cardJson = JSON.stringify(card);
                window.localStorage.setItem(viewId, cardJson);
                const urlDialogInfo = {
                    size: {
                        width: response.taskWeb?.value?.width || "large",
                        height: response.taskWeb?.value?.height,
                    },
                    url: window.location.href + "&viewId=" + viewId,
                };
                console.log(urlDialogInfo);
                dialog.url.open(urlDialogInfo, (err, result) => {
                    if (action.data?.msteams?.refreshOnSubmit !== undefined) {
                        // Reload the tab if submitting dialog requires a refresh
                        window.location.reload();
                    }
                    if (err) console.log(err);
                    if (result) console.log(result);
                });
            }
            else if (response?.tab) {
                // Update tab view if response offers a new tab card;
                const card = Array.isArray(response?.tab?.value?.cards) && response?.tab?.value?.cards[0] && response?.tab?.value?.cards[0].card;
                if (card) {
                    const adaptiveCard = this.renderCard(card);
                }
            }
            else {
                return dialog.url.submit();
            }
        }
        else if (action instanceof AdaptiveCards.OpenUrlAction) {
            window.open(action.url, "_blank");
        }
    }

    getCardInputData() {
        const card = this.state?.card;
        const map = {};
        if (typeof (card) === 'object') {
            for (const input of card.getAllInputs(true)) {
                if (!input.id) continue;
                const v = input.value;
                map[input.id] = v === undefined || v === null ? "" : String(v);
            }
        }
        return map;
    }

    renderCard(card) {
        // Create an AdaptiveCard instance
        const adaptiveCard = new AdaptiveCards.AdaptiveCard();
        // Set its hostConfig property unless you want to use the default Host Config
        // Host Config defines the style and behavior of a card
        let hostConfig = lightHostConfig;
        switch (this.state?.theme) {
            case "dark":
            case "contrast":
                hostConfig = darkHostConfig;
                import("./AdaptiveCardProxyDark.css");
                break;
            default:
                import("./AdaptiveCardProxyLight.css");
                break;
        }
        if (this.state?.frameContext === "task") {
            // Modal buttons should be aligned to the right
            hostConfig.actions.actionAlignment = "Right";
        }
        adaptiveCard.hostConfig = new AdaptiveCards.HostConfig(hostConfig);
        enableAdaptiveCardChartHostCapabilities(adaptiveCard.hostConfig);
        // Set the adaptive card's event handlers. onExecuteAction is invoked
        // whenever an action is clicked in the card
        adaptiveCard.onExecuteAction = this.submitAction;
        // Override Input.ChoiceSet to use Fluent UI so that we can implement search functionality
        AdaptiveCards.GlobalRegistry.elements.register("Input.ChoiceSet", InputChoiceSetFluentUI);

        // For markdown support you need a third-party library
        // E.g., to use markdown-it, include in your HTML page:
        //     <script type="text/javascript" src="https://unpkg.com/markdown-it/dist/markdown-it.js"></script>
        // And add this code to replace the default markdown handler:
        AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (text, result) {
            result.outputHtml = window.markdownit().render(text);
            result.didProcess = true;
        };

        // Parse the card payload
        adaptiveCard.parse(card);
        // Render the card to an HTML element:
        while (this.container && this.container.current.firstChild) {
            this.container.current.removeChild(this.container.current.lastChild);
        }
        const renderedCard = adaptiveCard.render();
        this.container.current.appendChild(renderedCard);
        wireCopyPopoverActions(renderedCard);
        this.setState({ card: adaptiveCard });
        return adaptiveCard;
    }

    async componentDidMount() {
        if (!iconsInitialized) {
            initializeIcons();
            iconsInitialized = true;
        }
        setAdaptiveCardSearch((searchText, dataSet, data) => this.fetchAdaptiveCardSearch(searchText, dataSet, data));

        let card;
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        try {
            if (params?.viewId) {
                card = JSON.parse(window.localStorage.getItem(params.viewId));
            } else if (params?.card) {
                card = JSON.parse(params.card);
            }
        } catch (e) {
            console.log(e);
        }
        try {
            await app.initialize();
            const context = await app.getContext();
            const authToken = await authentication.getAuthToken();
            if (context) {
                let appId = "56130ae1-5efd-40ca-b629-2c3da889bb32";
                // Get App Id from URL because it's not reliably passed in context
                if (params && params.appId) {
                    appId = params.appId;
                }
                const {
                    "app": {
                        theme,
                    },
                    "page": {
                        "id": tabId,
                        frameContext
                    },
                    "channel": channelInfo,
                    "chat": chatInfo,
                    "user": {
                        "id": userId,
                        "displayName": userDisplayName,
                        "tenant": {
                            "id": tenantId
                        }
                    },
                } = context;
                this.setState({
                    appId,
                    authToken,
                    frameContext,
                    tenantId,
                    userDisplayName,
                    teamId: context.team?.internalId,
                    conversationId: chatInfo?.id || channelInfo?.id,
                    theme,
                    userId,
                    tabId
                });
                this.renderCard(loadingCard);
                if (!card) {
                    const result = await this.fetchAdaptiveCard(BOT_ACTION_NAME.TAB_FETCH);
                    card = result?.tab?.value?.cards?.[0]?.card;
                }
            }
        }
        catch (e) {
            console.log(e);
        }

        if (card) {
            this.renderCard(card);
            if (window.parent !== window) {
                try { app.notifySuccess(); } catch (e) { console.log(e); }
            }
        }
        else {
            if (window.parent !== window) {
                try { app.notifyFailure({ reason: app.FailedReason.Timeout, message: "Couldn't load view from app." }); } catch (e) { console.log(e); }
            }
            this.renderCard(errorCard);
        }
    }

    componentWillUnmount() {
        clearAdaptiveCardSearch();
    }

    render() {
        return <div className="fullscreen-scrollable">
            <div ref={this.container}></div>
        </div>
    }
}

export default AdaptiveCardProxy;
